import { _ as __rest } from '../tslib.es6-c563c1dd.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, SvgIcon, Menu, MenuItem } from '@mui/material';
import { Calendar } from 'react-feather';

const PREFIX = 'FilterDate';
const classes = {
    root: `${PREFIX}-root`,
    actionIcon: `${PREFIX}-actionIcon`,
    button: `${PREFIX}-button`,
};
const Root = styled('div')(({ theme }) => ({
    [`& .${classes.root}`]: {},
    [`& .${classes.actionIcon}`]: {
        marginRight: theme.spacing(1),
    },
    [`& .${classes.button}`]: {
        color: theme.palette.text.secondary,
    },
}));
const FilterDate = (_a) => {
    var { timeRanges, selectionFunction } = _a, rest = __rest(_a, ["timeRanges", "selectionFunction"]);
    const actionRef = useRef(null);
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [timeRange, setTimeRange] = useState(timeRanges[2].text);
    const handleChange = (selected) => {
        setTimeRange(selected);
        const timeValue = timeRanges.find(time => time.text === selected);
        if (timeValue) {
            selectionFunction(timeValue.value);
        }
    };
    return (jsxs(Root, Object.assign({}, rest, { children: [jsxs(Button, Object.assign({ ref: actionRef, onClick: () => setMenuOpen(true), className: classes.button }, { children: [jsx(SvgIcon, Object.assign({ fontSize: "small", className: classes.actionIcon }, { children: jsx(Calendar, {}) })), timeRange] })), jsx(Menu, Object.assign({ anchorEl: actionRef.current, onClose: () => setMenuOpen(false), open: isMenuOpen, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, { children: timeRanges.map(t => (jsx(MenuItem, Object.assign({ onClick: () => handleChange(t.text) }, { children: t.text }), t.value))) }))] })));
};

export { FilterDate };
